/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ProcessDataModel {
        private systemLevel: Wars.Domain.Model.SystemLevel;
        private processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public objectSchema: Wars.Domain.Model.ObjectSchema;
        public reloadTree: boolean;
        public dataLoaded: boolean;
        public reloadData: () => void;
        public codeGroups: Wars.Domain.Model.Codes.CodeGroup[];

        constructor(
            private objectSchemaService: services.ObjectSchemaService,
            private processConfigurationService: services.ProcessConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private manageCodeService: services.ManageSystemCodesService,
            private growlService: angular.growl.IGrowlService,
            private processConfigId: string)
        {
            this.dataLoaded = false;
            this.loadDataInternal();

            this.reloadData = () => {
                this.loadDataInternal();
            };
        }

        private dataLoadedCallback(): void {
            this.dataLoaded = true;
        }

        private loadDataInternal(): void {
            if (this.processConfigId) {
                this.loadProcessConfigData(this.processConfigId);
            } else {
                this.loadSystemVariables();
            }
            this.loadCodes();
        }

        private loadProcessConfigData(processConfigId: string): void {
            
            this.processConfigurationService.getById(processConfigId).then(
                (processConfiguration) => {
                    this.processConfiguration = processConfiguration;
                    if (processConfiguration.processDataSchema_id) {
                        this.objectSchemaService.getObjectSchemaExpanded(processConfiguration.processDataSchema_id).then(
                        (objectSchema) => {
                            processConfiguration.processDataSchema = objectSchema;
                            this.objectSchema = objectSchema;
                            if (!objectSchema) {
                                processConfiguration.processDataSchema = this.objectSchemaService.createNewObjectSchema();
                                processConfiguration.processDataSchema_id = processConfiguration.processDataSchema.id;
                                this.objectSchemaService.saveAllChanges(() => {
                                    this.objectSchema = processConfiguration.processDataSchema;
                                    this.dataLoadedCallback();
                                });
                            } else {
                                this.dataLoadedCallback();
                            }
                        });

                    } else {
                        processConfiguration.processDataSchema = this.objectSchemaService.createNewObjectSchema();
                        processConfiguration.processDataSchema_id = processConfiguration.processDataSchema.id;
                        this.objectSchemaService.saveAllChanges(() => {
                            this.objectSchema = processConfiguration.processDataSchema;
                            this.dataLoadedCallback();
                        });
                    }
                });
        }

        private loadSystemVariables(): void {
           this.systemLevelService.getSystemLevel().then((systemLevel) => {
                this.systemLevel = systemLevel;
                this.objectSchemaService.getObjectSchemaExpanded(systemLevel.variableSchema_id).then(
                (objectSchema) => {
                    this.objectSchema = objectSchema;
                    this.dataLoadedCallback();
                });
            });
        }

        private loadCodes(): void {
            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.codeGroups = systemLevel.myCodeGroups;
                    if (this.processConfigId) {
                        this.manageCodeService.getAllCodesForProcessConfiguration(this.processConfigId).then(
                        (codeGroups) => {
                            this.codeGroups = this.codeGroups.concat(codeGroups);
                        });
                    }
                });
        }

        public save(): void {
            var validationResults = this.objectSchemaService.validateObjectSchema(this.objectSchema);
            if (validationResults.length === 0) {
                this.objectSchemaService.saveAllChanges(() => this.saveCallback());
            } else {
                validationResults.forEach(error => this.growlService.error(error));
            }
        }

        public saveCallback(): void {
            // We have to tie this end of the relationship up here after the initial save due to the fact that breeze cannot
            //  save both sides of a many-to-one to many-to-one (simulating one-to-one) at the same time because it does not
            //  know which one to save first.
            var moreChangesNecessary = false;
            for (var i = 0; i < this.objectSchema.properties.length; i++) {
                var currentSchemaProperty = this.objectSchema.properties[i];
                if (currentSchemaProperty.typeSchema !== null && currentSchemaProperty.typeSchema.parentProperty === null) {
                    moreChangesNecessary = true;
                    currentSchemaProperty.typeSchema.parentProperty = currentSchemaProperty;
                    currentSchemaProperty.typeSchema.schemaProperty_id = currentSchemaProperty.id;
                }
                if (currentSchemaProperty.typeSchema !== null && currentSchemaProperty.typeSchema.name !== currentSchemaProperty.name) {
                    moreChangesNecessary = true;
                    currentSchemaProperty.typeSchema.name = currentSchemaProperty.name;
                }
            }
            if (moreChangesNecessary) {
                this.save();
            } else {
                this.reloadTree = true;
            }
        }

        public cancel(): void {
            this.objectSchemaService.rejectChanges();
        }

        public hasChanges() {
            return this.objectSchemaService.hasChanges();
        }
    }
}